import { useEffect } from 'react';
import classnames from 'classnames';

import style from './EscapeButton.module.scss';

export interface EscapeButtonProps {
    modifiers?: EscapeButtonModifiers[];
}

interface Props extends EscapeButtonProps {
    onClose(): void;
}

export enum EscapeButtonModifiers {
    // @ts-ignore
    WithCrossIcon = style.root_withCrossIcon,
}

export const EscapeButton = ({ modifiers = [], onClose }: Props) => {
    useEffect(() => {
        function handleEscapeClick(e: KeyboardEvent) {
            if (e.key === 'Escape') {
                onClose();
            }
        }

        window.addEventListener('keydown', handleEscapeClick);

        return () => window.removeEventListener('keydown', handleEscapeClick);
    }, [onClose]);

    return <div className={classnames([style.root, ...modifiers])}>ESC</div>;
};
